import { Navigate, useLocation } from "react-router-dom";
import { getCookie } from "../utils/cookieUtils";

export const OnlyPublicAuth: any = ({ children, redirectTo }: any) => {
  const isAuthenticated = getCookie("token") ? true : false;
  return !isAuthenticated ? (
    children
  ) : (
    <Navigate to={{ pathname: redirectTo }} />
  );
};

export const RequireAuth: any = ({ children, redirectTo }: any) => {
  const isAuthenticated = getCookie("token") ? true : false;
  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={{ pathname: redirectTo }} />
  );
};

export const ProtectedRoute: any = ({
  children,
  redirectTo,
  allowCondition,
}: any) => {
  const location = useLocation();
  return allowCondition ? children : <Navigate to={{ pathname: redirectTo }} />;
};

// export function RoleBaseRoute({ children, redirectTo, roles }: any) {
//   return (
//     <ProtectedRoute
//       redirectTo={redirectTo}
//       allowCondition={grantPermission(roles)}
//     >
//       {children}
//     </ProtectedRoute>
//   );
// }
// export const grantPermission = ({requestedRoles}: any) => {
//   const permittedRoles = localStorage.getItem(USER_ROLE);
//   if (permittedRoles === requestedRoles) {
//     return true;
//   }
//   // in case of multiple roles, if one of the permittedRoles is present in requestedRoles, return true;
//   return true;
// };
